// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import { default as dayjs } from "dayjs";
import XLSXC from "xlsx-color";

const keywords = ["tutar", "kar", "komisyonu", "komisyon", "borç", "alacak", "bakiye", "toplam", "balance", "fark"];

const containsKeyword = (key) => {
  return keywords.some((keyword) => key.toLowerCase().includes(keyword));
};
const isNumeric = (value, key) => {
  if (key === "Banka Kodu" || key === "MasterPass Terminal Grup Id" || key === "Kartın Banka Kodu") return false;
  // Hem nokta hem de virgül içeren sayıları kabul eden regex
  const numericRegex = /^-?[0-9]+([.,][0-9]+)?$/;
  if (
    key === "Vergi Numarası" &&
    value.startsWith("0") &&
    numericRegex.test(value)
  ) {
    return false;
  }
  return numericRegex.test(value);
};

const formatDecimal = (key, value) => {
  if (containsKeyword(key) && isNumeric(value, key)) {
    let formattedValue = value.toString();
    // Nokta yerine virgül içeriyorsa, onu noktaya çevir
    if (formattedValue.includes(',')) {
      formattedValue = formattedValue.replace(',', '.');
    }
    return parseFloat(formattedValue).toFixed(2).replace('.', ',');
  }
  return value;
};




export const downloadExcel = (
  items: Array<any>,
  fileName?: string,
  keyMapping?: any
) => {
  const editedFileName =
    (fileName || "Dosya") +
    "_" +
    dayjs().format("DD/MM/YYYY HH:mm").toString() +
    ".xlsx";

  const ws_data = items.map((item) => {
    const styledRow = {};


    let cellStyle = undefined; // Varsayılan stil

    const specialStatusKey = keyMapping ? keyMapping["statusForExel"] : null;
    const specialTxnTypeKey = keyMapping ? keyMapping["txnTypeForExel"] : null;
    if (specialStatusKey && specialTxnTypeKey && item.hasOwnProperty(specialStatusKey) && item.hasOwnProperty(specialTxnTypeKey)) {
      const status = item[specialStatusKey].toUpperCase();
      const txnType = item[specialTxnTypeKey].toUpperCase();
      if (status === 'VOID' && txnType === 'AUTH') {
        cellStyle = {
          fill: { patternType: "solid", fgColor: { rgb: "FF0000" } },
          font: { color: { rgb: "ffffff" } },
        };
      } else if (status === 'SUCCESS' && txnType === 'REFUND') {
        cellStyle = {
          fill: { patternType: "solid", fgColor: { rgb: "FF0000" } },
          font: { color: { rgb: "ffffff" } },
        };
      }
      else if (status === 'UNMATCHED') {
        cellStyle = {
          fill: { patternType: "solid", fgColor: { rgb: "f0f0f0" } },
          font: { color: { rgb: "333333" } },
        };
      }
    }



    if (keyMapping && keyMapping["restriction"]) {
      if (item[keyMapping["restriction"]] === "Hayır") {
        cellStyle = {
          fill: { patternType: "solid", fgColor: { rgb: "FFFF0000" } },
          font: { color: { rgb: "FFFFFFFF" } },
        };
      }
    }
    const statusKeys = ["merchantStatusType", "status", "canCall"];

    for (const statusKey of statusKeys) {
      if (keyMapping && keyMapping[statusKey]) {
        if (item[keyMapping[statusKey]] === "PASSIVE") {
          cellStyle = {
            fill: { patternType: "solid", fgColor: { rgb: "FFFF0000" } },
            font: { color: { rgb: "FFFFFFFF" } },
          };
          break;
        } else if (item[keyMapping[statusKey]] === "BLOCKED") {
          cellStyle = {
            fill: { patternType: "solid", fgColor: { rgb: "FFFFA500" } },
            font: { color: { rgb: "FFFFFFFF" } },
          };

          break;
        }
        else if (item[keyMapping[statusKey]] === "Hayır") {
          cellStyle = {
            fill: { patternType: "solid", fgColor: { rgb: "FFFFA500" } },
            font: { color: { rgb: "FFFFFFFF" } },
          };

          break;
        }
      }
    }
    for (const key in item) {
      if (key !== specialStatusKey && key !== specialTxnTypeKey) {
        let value = item[key];

        // Eğer sayısal bir değerse ve ilgili anahtar kelimeleri içeriyorsa, formatla
        if (isNumeric(value, key) && containsKeyword(key)) {
          value = formatDecimal(key, value);
          // Excel hücresi için sayıyı sayı olarak ata
          styledRow[key] = {
            v: value !== " " ? parseFloat(value.replace(',', '.')) : value, // Boş değerse boş string, değilse sayısal değer
            t: value !== " " ? "n" : "s", // Boş değerse türü string, değilse sayısal
            s: { ...cellStyle, numFmt: "#,##0.00" },
          };
        } else {
          // Değer kontrolü
          if (value === null || value === undefined || value === "") {
            value = " "; // Excel hata vermesin diye boş string
          }
          // Excel hücresine değeri ata
          styledRow[key] = {
            v: value,
            t: typeof value === 'number' ? "n" : "s",
            s: cellStyle,
          };
        }
      }
    }
    return styledRow;
  });

  const defaultWidth = 20;
  const colWidths = [];

  const keys = Object.keys(ws_data[0]);

  for (const key of keys) {
    let maxDataLength = Math.max(
      ...ws_data.map((row) => String(row[key]?.v).length)
    );
    let headerLength = key.length; // sütun başlığının uzunluğunu al

    let maxLength = Math.max(maxDataLength, headerLength);

    if (maxLength > defaultWidth) {
      maxLength = defaultWidth;
    }

    colWidths.push({ wch: maxLength });
  }

  const workbook = XLSXC.utils.book_new();
  const worksheet = XLSXC.utils.json_to_sheet(ws_data, { cellStyles: true });

  // Hesaplanan sütun genişliklerini exele atıyoruz
  worksheet["!cols"] = colWidths;

  // Başlık stili için hücre tarzını tanımlıyoruz
  const headerStyle = {
    fill: { patternType: "solid", fgColor: { rgb: "0000A0" } }, // Başlık rengi burdan değişiyor
    font: { color: { rgb: "FFFFFF" }, bold: true },
  };

  // Başlık hücrelerini bu stille güncellenir
  keys.forEach((key, idx) => {
    const cellRef = XLSXC.utils.encode_cell({ r: 0, c: idx });
    if (!worksheet[cellRef]) worksheet[cellRef] = {};
    worksheet[cellRef].s = headerStyle;
  });

  XLSXC.utils.book_append_sheet(workbook, worksheet, `Excel`);
  XLSXC.writeFile(workbook, editedFileName);
};
